module.exports = {
	"id": "AM",
	"name": "Armenia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.184632,
			"5": 0.070336,
			"6": 0.096712,
			"7": 0.114296,
			"8": 0.052752,
			"9": 0.052752,
			"10": 0.070336,
			"11": 0.070336,
			"12": 0.123088,
			"13": 0.096712,
			"14": 0.123088,
			"15": 0.070336,
			"16": 0.114296,
			"17": 0.140672,
			"18": 0.211008,
			"19": 0.184632,
			"20": 0.2198,
			"21": 0.13188,
			"22": 0.193424,
			"23": 0.202216,
			"24": 0.254968,
			"25": 0.17584,
			"26": 0.17584,
			"27": 0.193424,
			"28": 0.035168,
			"29": 0.061544,
			"30": 0.04396,
			"31": 0.04396,
			"32": 0.035168,
			"33": 0.052752,
			"34": 0.070336,
			"35": 0.079128,
			"36": 0.035168,
			"37": 0.070336,
			"38": 0.096712,
			"39": 0.158256,
			"40": 0.281344,
			"41": 0.184632,
			"42": 0.114296,
			"43": 0.26376,
			"44": 0.035168,
			"45": 0.052752,
			"46": 0.04396,
			"47": 0.123088,
			"48": 0.096712,
			"49": 2.866192,
			"50": 0.167048,
			"51": 0.650608,
			"52": 0.474768,
			"53": 27.765136,
			"54": 10.743824,
			"55": 0.2198,
			"56": 0.079128,
			"57": null
		},
		"firefox": {
			"2": 0.114296,
			"3": 0.378056,
			"4": 0.105504,
			"5": 0.017584,
			"6": 0.008792,
			"7": 0.035168,
			"8": null,
			"9": 0.017584,
			"10": 0.052752,
			"11": 0.035168,
			"12": null,
			"13": 0.017584,
			"14": 0.061544,
			"15": 0.08792,
			"16": null,
			"17": 0.026376,
			"18": 0.017584,
			"19": 0.026376,
			"20": 0.052752,
			"21": 0.035168,
			"22": 0.026376,
			"23": 0.035168,
			"24": 0.026376,
			"25": 0.035168,
			"26": 0.017584,
			"27": 0.017584,
			"28": 0.017584,
			"29": 0.026376,
			"30": 0.008792,
			"31": 0.08792,
			"32": 0.008792,
			"33": 0.04396,
			"34": 0.061544,
			"35": 0.061544,
			"36": 0.061544,
			"37": 0.035168,
			"38": 0.158256,
			"39": 0.017584,
			"40": 0.017584,
			"41": 0.017584,
			"42": 0.04396,
			"43": 0.105504,
			"44": 0.017584,
			"45": 0.052752,
			"46": 0.061544,
			"47": 0.597856,
			"48": 9.908584,
			"49": 9.214016,
			"50": 0.017584,
			"51": null,
			"52": null,
			"3.5": 0.553896,
			"3.6": 1.49464
		},
		"opera": {
			"9": null,
			"11": 0.052752,
			"12": 0.413224,
			"15": 0.04396,
			"16": 0.008792,
			"17": 0.061544,
			"18": 0.035168,
			"19": 0.017584,
			"20": 0.105504,
			"21": 0.035168,
			"22": 0.017584,
			"23": 0.017584,
			"24": 0.04396,
			"25": 0.035168,
			"26": 0.026376,
			"27": 0.325304,
			"28": 0.079128,
			"29": 0.017584,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.017584,
			"34": 0.008792,
			"35": null,
			"36": 0.096712,
			"37": 0.035168,
			"38": 0.08792,
			"39": 0.035168,
			"40": 1.028664,
			"41": 0.254968,
			"42": null,
			"43": null,
			"9.5-9.6": 0.008792,
			"10.0-10.1": 0.026376,
			"10.5": 0.04396,
			"10.6": 0.167048,
			"11.1": 0.158256,
			"11.5": 0.061544,
			"11.6": 0.457184,
			"12.1": 1.564976
		},
		"safari": {
			"0": null,
			"4": 0.167048,
			"5": 0.2198,
			"6": 0.035168,
			"7": 0.026376,
			"8": 0.096712,
			"9": 0.035168,
			"10": 0.30772,
			"3.1": 0.052752,
			"3.2": 0.017584,
			"5.1": 0.228592,
			"6.1": 0.052752,
			"7.1": null,
			"9.1": 0.140672
		},
		"ios_saf": {
			"8": 0,
			"10": 2.12639683597,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0573039342215,
			"8.1-8.4": 0.105866590341,
			"9.0-9.2": 0.0505051623647,
			"9.3": 0.770527477102
		},
		"android": {
			"3": 0,
			"4": 0.0175893540052,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00219866925065,
			"4.1": 0.0634473126615,
			"4.2-4.3": 0.158618281654,
			"4.4": 0.363722713178,
			"4.4.3-4.4.4": 0.366863669251
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.585231589744,
			"9": 0.376928820513,
			"10": 0.466201435897,
			"11": 0.892726153846,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0410702895931,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00114084137759
		},
		"edge": {
			"12": 0.035168,
			"13": 0.13188,
			"14": 0.2198
		},
		"ie_mob": {
			"10": 0.0590729014085,
			"11": 0.240511098592
		},
		"bb": {
			"7": 0.011778,
			"10": null
		},
		"samsung": {
			"0": 0.635408
		},
		"and_uc": {
			"0": 0.3624
		},
		"op_mini": {
			"0": 0.553332869029
		},
		"and_chr": {
			"0": 6.739616
		},
		"and_ff": {
			"0": 0.01812
		}
	},
	"total": 94.431962
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AM.json
 ** module id = 461
 ** module chunks = 0
 **/